(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-carousel"]) return;
  try {
    
(function(){
  function initCarouselInstance(carouselEl) {
    if (!carouselEl) return;
    // prevent double init
    if (carouselEl.dataset.carouselInit === 'true') return;
    carouselEl.dataset.carouselInit = 'true';

    var track = carouselEl.querySelector('[data-track]');
    var blockWrapper = carouselEl.closest('.collection-block');
    var prevBtn = blockWrapper && blockWrapper.querySelector('.carousel__btn.prev');
    var nextBtn = blockWrapper && blockWrapper.querySelector('.carousel__btn.next');
    var dotsWrap = carouselEl.querySelector('[data-dots]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.children);
    var total = items.length;
    var index = 0;

    function visibleCount() {
      var w = window.innerWidth;
      if (w <= 480) return 1;
      if (w <= 800) return 2;
      if (w <= 1100) return 3;
      return 4;
    }

    function update() {
      var visible = visibleCount();
      var maxIndex = Math.max(0, total - visible);
      if (index > maxIndex) index = maxIndex;
      var item = items[0];
      if (!item) return;
      var itemWidth = item.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 18;
      var translateX = (itemWidth + gap) * index;
      track.style.transform = 'translateX(-' + translateX + 'px)';

      if (prevBtn) prevBtn.disabled = (index === 0);
      if (nextBtn) nextBtn.disabled = (index === maxIndex);

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        var steps = Math.max(1, maxIndex + 1);
        for (var i = 0; i < steps; i++) {
          var d = document.createElement('button');
          d.className = 'carousel__dot' + (i === index ? ' is-active' : '');
          d.type = 'button';
          d.dataset.idx = i;
          d.addEventListener('click', function (e) {
            index = parseInt(this.dataset.idx, 10);
            update();
          });
          dotsWrap.appendChild(d);
        }
      }
    }

    function next() {
      var visible = visibleCount();
      var maxIndex = Math.max(0, total - visible);
      index = Math.min(maxIndex, index + 1);
      update();
    }
    function prev() {
      index = Math.max(0, index - 1);
      update();
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    // touch support
    var startX = 0, isDown = false;
    track.addEventListener('pointerdown', function(e){
      isDown = true; startX = e.clientX; track.style.transition = 'none';
    }, {passive:true});
    window.addEventListener('pointermove', function(e){
      if (!isDown) return;
      var dx = e.clientX - startX;
      track.style.transform = 'translateX(' + (-((items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap)||18)) * index) + dx) + 'px)';
    }, {passive:true});
    window.addEventListener('pointerup', function(e){
      if (!isDown) return;
      isDown = false; track.style.transition = 'transform 360ms cubic-bezier(.22,.95,.2,1)';
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next(); else prev();
      } else {
        update();
      }
    });

    // reflow on resize
    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 120);
    });

    // initial update (slightly delayed to ensure images loaded)
    setTimeout(update, 60);
    // also update after all images in track load (handles slow images)
    var imgs = track.querySelectorAll('img');
    if (imgs.length) {
      var loadedCount = 0;
      imgs.forEach(function(img){
        if (img.complete) { loadedCount++; return; }
        img.addEventListener('load', function(){ loadedCount++; if (loadedCount === imgs.length) setTimeout(update, 30); });
        img.addEventListener('error', function(){ loadedCount++; if (loadedCount === imgs.length) setTimeout(update, 30); });
      });
    }
  }

  function initAllCarousels() {
    var carousels = document.querySelectorAll('[data-carousel-id]');
    carousels.forEach(function(c){
      initCarouselInstance(c);
    });
  }

  // run on initial load
  document.addEventListener('DOMContentLoaded', initAllCarousels);
  // Also trigger immediately in case DOMContentLoaded already fired (Shopify editor)
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAllCarousels();
  }

  // Re-init when Shopify customizer loads or sections update (supports section preview)
  window.addEventListener('shopify:section:load', initAllCarousels);
  window.addEventListener('shopify:section:select', initAllCarousels);
  window.addEventListener('shopify:block:select', initAllCarousels);

  // A fallback: re-init after 1 second for editor race conditions
  setTimeout(initAllCarousels, 900);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
